import PropTypes from 'prop-types';
import React from 'react';
import { Question } from '../Question';
import { RadioButton } from './RadioButton';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../../shared/forms';

export class Row extends React.Component {
  onRadioCheckboxChange = (event) => {
    this.onChange(event);
  }

  onChange = (event) => {
    this.props.updateAnswer(
      this.props.questionnaireItem.questionnaireItemId,
      {
        listAnswerId: event,
      });

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }


  render = () => {
    const { questionnaireItem } = this.props;
    return (
      <div className={this.props.questionnaireItem.isValid === false ? "question-area form-group is-invalid":"question-area form-group"}>
        <Question
          questionNumber={questionnaireItem.questionNumber}
          formattedText={questionnaireItem.formattedText}
          isRequired={questionnaireItem.isRequired}
          isValid={ questionnaireItem.isValid }
          className="cell"
          isMatrix={true}
        />
        {questionnaireItem.listAnswers.map(listAnswerItem => (
          <RadioButton listAnswerItem={listAnswerItem} key={listAnswerItem.listAnswerId}
            onChange={this.onRadioCheckboxChange} disabled={this.props.disabled}
            answerItem={this.props.answer}
          />
        ))}
      </div>
    );
  }
}

Row.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answer: PropTypes.object,
};
